<template lang="pug">
.doc-zoomer(@click="click" @mouseenter="enter", @mousemove="conditionalClose", @mouseleave="remove", :style="style", :class="{ 'for-engage': engageSection }")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
let removeTimer;
export default {
  name: 'docZoomer',
  props: {
    url: String
  },
  computed: {
    ...mapGetters(['engageSection', 'engageShown']),
    ...vuexComputed('folderDoco', 'insightsDoco', 'insightsShown', 'folderZoomedDoc', 'engageSection'),
    style() {
      const { folderZoomedDoc: { img }, top, left, width, height } = this;
      return { 'background-image': img && `url('${ img }')`, ...top, ...left, ...width, ...height };
    },
    top() {
      const { top } = this.folderZoomedDoc;
      return (top !== undefined && { top: `${ top }px` }) || {};
    },
    left() {
      const { left } = this.folderZoomedDoc;
      return (left !== undefined && { left: `${left}px` }) || {};
    },
    width() {
      const { width } = this.folderZoomedDoc;
      return (width !== undefined && { width: `${ width }px` }) || {};
    },
    height() {
      const { height } = this.folderZoomedDoc;
      return (height !== undefined && { height: `${ height }px` }) || {};
    }
  },
  methods: {
    ...mapActions(['loadDoco', 'loadInsights', 'toggleEngageSelectedDocument']),
    enter() {
      clearTimeout(removeTimer);
    },
    remove() {
      clearTimeout(removeTimer);
      removeTimer = setTimeout(() => (this.folderZoomedDoc = {}), 250);
    },
    async click() {
      const { folderZoomedDoc, engageSection, engageShown, loadInsights, loadDoco, toggleEngageSelectedDocument } = this;
      const { id } = folderZoomedDoc;
      console.log('doc-zoomer click', id, engageSection);
      if (engageSection && engageShown) {
        toggleEngageSelectedDocument(id);
      } else {
        console.log('openInsights from doc zoomer', id);
        this.folderDoco = id;
        this.insightsDoco = id;
        await loadInsights({ id });
        this.insightsShown = true;
        loadDoco(id);
        console.log('openInsights done', id);
      }
    },
    conditionalClose(e) {
      const { clientX, clientY } = this.folderZoomedDoc || {};
      const threshold = 100;
      const delta = Math.abs(clientX - e.clientX) + Math.abs(clientY - e.clientY);
      if (delta > threshold) {
        console.log('conditionalClose...');
        this.folderZoomedDoc = {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/global';
.doc-zoomer {
  position: absolute;
  top: 0;
  right: 0;
  //align-self: top;
  //width: 5rem;
  //height: 6.875rem;
  //width: 4rem;
  //height: 5.5rem;
  background: white no-repeat center;
  background-size: contain;
  border: 1px solid #ececec;
  will-change: transform;
  transition: transform 250ms ease-in-out;
  transform-origin: center center;
  &.for-engage {
    &:hover {
      transform: scale(2);
    }
  }
  &:hover {
    transform: scale(3);
  }
}
</style>
